export const joinClassNames = (...str: (string | undefined)[]) => str.filter((x) => x).join(' ');
